import { Button, Card, FormGroup, InputGroup } from "@blueprintjs/core";
import * as React from "react";
import { RouteComponentProps } from "react-router";

interface IState {
  email: string;
}

export default class Auth extends React.Component<
  RouteComponentProps<{}>,
  IState
> {
  public readonly state: IState = {
    email: ""
  };

  public render() {
    const { email } = this.state;

    return (
      <div>
        <Card>
          <h3>Please enter your email</h3>
          <p>
            Before you start, you should give us your email, so we can track
            your progress. Your browser remembers this after the first time.
          </p>

          <form method="post" onSubmit={this.handleSave}>
            <FormGroup>
              <InputGroup
                onChange={this.handleEmailChange}
                value={email}
                autoFocus={true}
                placeholder="e.g. jane@doe.com"
              />
            </FormGroup>

            <Button type="submit" intent="primary">
              Save email
            </Button>
          </form>
        </Card>
      </div>
    );
  }

  public handleEmailChange = (event: React.FormEvent<HTMLInputElement>) => {
    this.setState({ email: event.currentTarget.value.toLowerCase() });
  };

  public handleSave = (event: React.MouseEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (this.state.email.trim() === "") {
      return;
    }

    localStorage.setItem("user_slug", this.state.email);
    this.props.history.push(this.props.location.state.from || "/");
  };
}



// WEBPACK FOOTER //
// ./src/pages/Auth.tsx